import { render } from "./IUserPicker.vue?vue&type=template&id=22a79742"
import script from "./IUserPicker.vue?vue&type=script&lang=js"
export * from "./IUserPicker.vue?vue&type=script&lang=js"

import "./IUserPicker.vue?vue&type=style&index=0&id=22a79742&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__